// @ts-nocheck
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
// import Page from "@insite/mobius/Page"; // Starter Custom Code
import * as React from "react";
import { ReactNode } from "react";
// import styled from "styled-components"; // Starter Custom Code

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Page, { PageProps } from "@insite/mobius/Page";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import OnePageCheckoutProductListOverlay from "@store/Framework/Components/OnePageCheckoutProductListOverlay";
import KeepMeLoggedInModal from "@store/Library/Components/Toolkit/KeepMeLoggedInModal";
import SiteWrapper, { SiteWrapperPresentationProps } from "@store/Library/Components/Toolkit/SiteWrapper";
import { headerMobileSelector } from "@store/Themes/common/mixins/header";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import ExperimentsSnippets from "@toolkit/Library/Components/Injectors/ExperimentsSnippets";
import FraudProtectionFingerprint from "@toolkit/Library/Components/Injectors/FraudProtection/FraudProtectionFingerprint";
import GoogleAnalytics from "@toolkit/Library/Components/Injectors/GoogleAnalytics";
import { stretchStyles } from "@toolkit/Themes/common/mixins";
import styled, { css } from "styled-components";

export interface PageLayoutStyles {
    siteWrapper?: SiteWrapperPresentationProps;
    content?: InjectableCss;
    // Starter Custom Code
    header?: InjectableCss;
    breadcrumb?: PageProps;
    footer?: InjectableCss;
}

const pageLayoutStyles: PageLayoutStyles = {
    header: {
        css: css`
            position: relative;
            z-index: 4;

            > ${StyledWrapper}:first-child:last-child {
                background-color: ${getColor("header")};
                opacity: 1;
                animation: none;
                box-sizing: content-box;

                ${({ theme }) => css`
                    ${breakpointValues(theme.design.header.height, "height")}
                    ${breakpointValues(
                        theme.design.menu.secondaryNavigation.height.map(x => {
                            if (!x) {
                                return null;
                            }

                            return css`
                                border-top: ${x} solid ${getColor("menu.secondaryNavigation")};
                            `;
                        }),
                    )}
                    ${breakpointValues(
                        theme.design.menu.mainNavigation.height.map(x => {
                            if (!x) {
                                return null;
                            }

                            return css`
                                border-bottom: ${x} solid ${getColor("menu.mainNavigation")};
                            `;
                        }),
                    )}
                `}

                ${headerMobileSelector()} {
                    border: none;
                }

                svg {
                    display: none; /* Disable DelayedSpinner */
                }
            }
        `,
    },
    breadcrumb: {
        css: css`
            position: relative;
            z-index: 3;

            @media print {
                display: none;
            }
        `,
    },
    content: {
        css: css`
            ${stretchStyles()}
            position: relative;
            z-index: 2;
        `,
    },
    footer: {
        css: css`
            position: relative;
            z-index: 1;
        `,
    },
};

const styles = pageLayoutStyles;
/* Starter Custom Code - End */

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
}: PageLayoutProps) => {
    return (
        <SiteWrapper {...styles.siteWrapper /* Starter Custom Code */}>
            {/* Starter Custom Code - Start */}
            {showHeader && <StyledWrapper {...styles.header}>{header}</StyledWrapper>}
            {/* Starter Custom Code - End */}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page as="div" {...styles.breadcrumb /* Starter Custom Code */}>
                    <PageBreadcrumbs />
                </Page>
            )}
            {/* Starter Custom Code - Start */}
            <StyledWrapper {...styles.content}>{pageContent}</StyledWrapper>
            {showFooter && <StyledWrapper {...styles.footer}>{footer}</StyledWrapper>}
            <ExperimentsSnippets />
            <GoogleAnalytics />
            <FraudProtectionFingerprint />
            <KeepMeLoggedInModal />
            <OnePageCheckoutProductListOverlay />
            {/* Starter Custom Code - End */}
            {showSignInOverlay && signInOverlay}
            {showStorePickupOverlay && storePickupOverlay}
            {showAddressBookOverlay && addressBookOverlay}
            <CookiePrivacyPolicyPopup />
        </SiteWrapper>
    );
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
    }

    @media print {
        display: block;
    }
`;

export default PageLayout;
